<template>
  <UApp :locale="ptBr" :toaster="{ position: 'bottom-left', class: 'dark' }">
    <NuxtLoadingIndicator />
    <NuxtPage />
  </UApp>
</template>

<script setup>
  import { pt_br as ptBr } from '@nuxt/ui/locale'

  // a paleta agora é fixa do Design System (flame/stone) — a aparência só
  // escolhe Claro/Escuro; limpa as preferências de cor gravadas antigamente
  localStorage.removeItem('plunni-primary')
  localStorage.removeItem('plunni-neutral')

  // mesmo atalho do worqspace: meta_g = Ctrl+G (⌘G no Mac) alterna Claro/Escuro
  const colorMode = useColorMode()
  defineShortcuts({
    meta_g: () => {
      colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
    }
  })
</script>